import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

function formatDate(iso) {
  try {
    const d = new Date(iso);
    const pad = (n) => String(n).padStart(2, '0');
    return pad(d.getDate())+'.'+pad(d.getMonth()+1)+'.'+d.getFullYear()
      +' '+pad(d.getHours())+':'+pad(d.getMinutes());
  } catch (_) { return iso || ''; }
}

function formatSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return bytes + ' Б';
  if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' КБ';
  return (bytes / 1048576).toFixed(2) + ' МБ';
}

export default function BackupRestoreModal({ onClose }) {
  const [backups, setBackups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [restoringId, setRestoringId] = useState(null);
  const [confirmBackup, setConfirmBackup] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await supabase.rpc('list_user_backups');
        if (cancelled) return;
        if (error) {
          setErrorMessage('Не удалось получить список архивов: ' + (error.message || ''));
          setIsLoading(false);
          return;
        }
        setBackups(Array.isArray(data) ? data : []);
        setIsLoading(false);
      } catch (e) {
        if (cancelled) return;
        setErrorMessage('Ошибка загрузки архивов');
        setIsLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const restoreBackup = (backup) => setConfirmBackup(backup);

  const doRestore = async (backup) => {
    setConfirmBackup(null);
    setRestoringId(backup.backup_id);
    setErrorMessage('');
    try {
      const { error } = await supabase.rpc('restore_user_backup', { backup_id: backup.backup_id });
      if (error) {
        setErrorMessage('Не удалось восстановить: ' + (error.message || ''));
        setRestoringId(null);
        return;
      }
      // После восстановления — перезагрузка, чтобы подтянуть новые данные.
      window.location.reload();
    } catch (e) {
      setErrorMessage('Ошибка восстановления');
      setRestoringId(null);
    }
  };

  return (
    <div className="backup-modal-overlay" onClick={onClose}>
      <div className="backup-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="backup-modal-close"
          onClick={onClose}
          aria-label="Закрыть"
        >×</button>
        <h2 className="backup-modal-title">Восстановить из архива</h2>
        <p className="backup-modal-subtitle">
          Резервные копии создаются автоматически раз в сутки.
          Хранятся 3 последних снимка.
        </p>

        {isLoading && (
          <div className="backup-modal-empty">Загрузка...</div>
        )}

        {!isLoading && errorMessage && (
          <div className="backup-modal-error">{errorMessage}</div>
        )}

        {!isLoading && !errorMessage && backups.length === 0 && (
          <div className="backup-modal-empty">
            Архивов пока нет. Первый снимок появится после следующего входа.
          </div>
        )}

        {!isLoading && !errorMessage && backups.length > 0 && (
          <ul className="backup-modal-list">
            {backups.map((b) => (
              <li key={b.backup_id} className="backup-modal-item">
                <div className="backup-modal-item-info">
                  <div className="backup-modal-item-date">
                    {formatDate(b.backup_created_at)}
                  </div>
                  <div className="backup-modal-item-meta">
                    {formatSize(b.data_size)}
                    {b.source === 'email' && (
                      <span className="backup-modal-source-tag">из старого аккаунта</span>
                    )}
                  </div>
                </div>
                <button
                  type="button"
                  className="backup-modal-restore-btn"
                  onClick={() => restoreBackup(b)}
                  disabled={restoringId !== null}
                >
                  {restoringId === b.backup_id ? 'Восстанавливаю...' : 'Восстановить'}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      {confirmBackup && (
        <div className="subcat-delete-overlay" onClick={() => setConfirmBackup(null)}>
          <div className="subcat-delete-card" onClick={(e) => e.stopPropagation()}>
            <p className="subcat-delete-title">Восстановить базу?</p>
            <p className="subcat-delete-sub">Архив от {formatDate(confirmBackup.backup_created_at)}. Текущая база будет полностью заменена этим архивом. Это действие нельзя отменить.</p>
            <div className="subcat-delete-actions">
              <button type="button" className="subcat-delete-cancel" onClick={() => setConfirmBackup(null)}>Отмена</button>
              <button type="button" className="subcat-delete-confirm" onClick={() => doRestore(confirmBackup)}>Восстановить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
